import { Action, State } from './quickSearch.types';

export const initialState: State = {
  activeConversation: null,
  activeIndex: null,
  direction: 'down',
  filteredItems: [],
  items: [],
  isOpen: false,
  query: '',
};

const filterItems = (query: string, items: State['items']): State['filteredItems'] => {
  const name = query.toLowerCase();

  return items.filter((item) => item.name.toLowerCase().includes(name));
};

const getActiveItem = (items: State['items']) => (items.length ? items[0] : null);

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'open': {
      const filteredItems = state.items;
      const activeConversation = getActiveItem(filteredItems);

      return {
        ...state,
        activeConversation,
        activeIndex: activeConversation ? 0 : null,
        filteredItems: state.items,
        query: '',
        isOpen: true,
      };
    }

    case 'close': {
      return {
        ...state,
        activeConversation: null,
        activeIndex: null,
        filteredItems: state.items,
        query: '',
        isOpen: false,
      };
    }

    case 'queryChange': {
      const filteredItems = filterItems(action.payload, state.items);
      const activeConversation = getActiveItem(filteredItems);

      return {
        ...state,
        activeConversation,
        activeIndex: activeConversation ? 0 : null,
        filteredItems,
        query: action.payload,
      };
    }

    case 'navigate': {
      if (action.payload === 'wheel') {
        return {
          ...state,
          activeConversation: null,
          activeIndex: null,
          direction: action.payload,
        };
      }

      const currentActiveIndex = state.activeIndex;
      let activeIndex = null;
      if (action.payload === 'down') {
        activeIndex =
          currentActiveIndex === null ? 0 : (currentActiveIndex + 1) % state.filteredItems.length;
      } else if (action.payload === 'up') {
        activeIndex =
          currentActiveIndex === null
            ? state.filteredItems.length - 1
            : (state.filteredItems.length + currentActiveIndex - 1) % state.filteredItems.length;
      }

      return {
        ...state,
        activeConversation: state.filteredItems[activeIndex],
        activeIndex,
        direction: action.payload,
      };
    }

    case 'setData': {
      const filteredItems = filterItems(state.query, action.payload);
      const activeConversation = getActiveItem(filteredItems);

      return {
        ...state,
        activeConversation,
        activeIndex: activeConversation ? 0 : null,
        filteredItems,
        items: action.payload,
      };
    }

    default: {
      throw new Error('unsupported action.type');
    }
  }
};
